import { render } from "./topic-detail.vue?vue&type=template&id=24832ebd&ts=true"
import script from "./topic-detail.vue?vue&type=script&lang=ts"
export * from "./topic-detail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__